import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SERVICE_DETAIL_BANNERS } from '../service-detail-banners';
import { ServiceOrbitVisualComponent } from '../shared/service-orbit-visual/service-orbit-visual.component';


@Component({
  selector: 'app-data-science',
  standalone: true,
  imports: [CommonModule, RouterLink, ServiceOrbitVisualComponent],
  templateUrl: './data-science.component.html',
  styleUrl: './data-science.component.scss',
  host: {
    '[style.--service-banner-image]': 'serviceBannerImage',
  },
})
export class DataScienceComponent {
  readonly serviceBannerImage = SERVICE_DETAIL_BANNERS.dataScience;
}
